import React from 'react'
import { countActivePointsBuckets, countActivePointsBucketsWeek, countDoneBuckets, countDoneBucketsWeek, countDoneLucketsPastWeek } from '../../slice/lucket-model/countBuckets'
import { fontColourCalculator, lifeStatusCalculator, lifeWeekStatusCalculator } from '../../slice/lucket-model/model'
import './index.css'
import { Chip, Tooltip } from '@mui/material'
import { LUCKET_DETAILS_BACKGROUND_COLOR, STATUS_OPTION_HEX_PALLETE } from '../../constants'

const LucketRelativePointsIcon = (props) => {
    let totalActionPoints = countActivePointsBuckets(props.luckets, props.currentDate)
    let doneActionPoints = countDoneBuckets(props.luckets, props.currentDate)
    let minColor = lifeStatusCalculator(props.luckets, props.currentDate)

    let totalActionPointsWeek = countActivePointsBucketsWeek(props.luckets, props.currentDate)
    let doneActionPointsWeek = countDoneBucketsWeek(props.luckets, props.currentDate)
    let minColorWeek = lifeWeekStatusCalculator(props.luckets, props.currentDate)

    let totalBluesInCurrentWeek = countDoneLucketsPastWeek(props.luckets, props.currentDate)
    // const status = props.lucket.childrenActionStatus;
    const className = 'LucketRelativePointsIcon';
    const classNameWeek = 'LucketRelativePointsIcon';

    return (<div>
        <Tooltip title="Done Daily Action Points vs Total Daily Action Points" placement="top" >
            <Chip
                className={className}
                label={`${doneActionPoints} - ${totalActionPoints}`}
                style={{
                    color: fontColourCalculator(minColor), fontWeight: "bold",
                    backgroundColor: STATUS_OPTION_HEX_PALLETE[minColor],
                    borderColor: LUCKET_DETAILS_BACKGROUND_COLOR
                }}
            />
        </Tooltip>
        <Tooltip title="Done Weekly Action Points vs Total Weekly Action Points">
            <Chip className={classNameWeek}
                style={{
                    color: fontColourCalculator(minColorWeek), fontWeight: "bold",
                    backgroundColor: STATUS_OPTION_HEX_PALLETE[minColorWeek],
                    borderColor: LUCKET_DETAILS_BACKGROUND_COLOR
                }}
                label={`${totalBluesInCurrentWeek} - ${totalActionPointsWeek}`}
            />
        </Tooltip>
    </div>
    )
}

export default LucketRelativePointsIcon